import { render, staticRenderFns } from "./ProductArrangements.vue?vue&type=template&id=52552c4e"
import script from "./ProductArrangements.vue?vue&type=script&lang=js"
export * from "./ProductArrangements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports